"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LoginPageState = /** @class */ (function () {
    function LoginPageState() {
        this.doingSessionRefresh = false;
        this.intentCheck = false;
    }
    return LoginPageState;
}());
exports.default = LoginPageState;
//# sourceMappingURL=LoginPageState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/LoginPage/LoginPageState.js
// module id = 1692
// module chunks = 8